// Application entrypoint - sets up Stimulus and rails-ujs

import { Application } from "@hotwired/stimulus"
import Rails from "@rails/ujs"
import Pagy from "@/lib/pagy"

// Start Rails UJS
Rails.start()

// Initialize Pagy pagination
window.addEventListener("load", Pagy.init)
window.addEventListener("turbo:load", Pagy.init)
window.addEventListener("turbolinks:load", Pagy.init)

// Start Stimulus application
const application = Application.start()

// Configure Stimulus development experience
application.debug = false
;(window as typeof window & { Stimulus: Application }).Stimulus = application

// Import all Stimulus controllers
import AiReviewController from "@/controllers/ai_review_controller"
import BillingToggleController from "@/controllers/billing_toggle_controller"
import BreakerPanelController from "@/controllers/breaker_panel_controller"
import CategoryPanelController from "@/controllers/category_panel_controller"
import DocumentUploadController from "@/controllers/document_upload_controller"
import DonutChartController from "@/controllers/donut_chart_controller"
import FloorPlanMapperController from "@/controllers/floor_plan_mapper_controller"
import HelloController from "@/controllers/hello_controller"
import HomeExplorerController from "@/controllers/home_explorer_controller"
import LinkAccountController from "@/controllers/link_account_controller"
import LightweightChartController from "@/controllers/lightweight_chart_controller"
import RuleBuilderController from "@/controllers/rule_builder_controller"
import NavigationController from "@/controllers/navigation_controller"
import NotificationController from "@/controllers/notification_controller"
import PlaidController from "@/controllers/plaid_controller"
import PlanZoomController from "@/controllers/plan_zoom_controller"
import AccountTypeOverrideController from "@/controllers/account_type_override_controller"
import PurposeAssignmentController from "@/controllers/purpose_assignment_controller"
import TabsController from "@/controllers/tabs_controller"

// Register all controllers
application.register("account-type-override", AccountTypeOverrideController)
application.register("ai-review", AiReviewController)
application.register("billing-toggle", BillingToggleController)
application.register("breaker-panel", BreakerPanelController)
application.register("category-panel", CategoryPanelController)
application.register("document-upload", DocumentUploadController)
application.register("donut-chart", DonutChartController)
application.register("floor-plan-mapper", FloorPlanMapperController)
application.register("hello", HelloController)
application.register("home-explorer", HomeExplorerController)
application.register("link-account", LinkAccountController)
application.register("lightweight-chart", LightweightChartController)
application.register("navigation", NavigationController)
application.register("rule-builder", RuleBuilderController)
application.register("notification", NotificationController)
application.register("plaid", PlaidController)
application.register("plan-zoom", PlanZoomController)
application.register("purpose-assignment", PurposeAssignmentController)
application.register("tabs", TabsController)

export { application }
